// Fingerprint de ficheiro para deduplicação: tamanho + SHA-256(início 4MB + meio 4MB + fim 4MB).
// Rápido mesmo em ficheiros de vários GB (lê no máximo 12 MB) e robusto contra colisões.
// TEM de bater com a receita do servidor (routers/dedup.py).
export async function fileFingerprint(file) {
  try {
    const CHUNK = 4 * 1024 * 1024;
    const head = file.slice(0, CHUNK);
    const midStart = Math.max(0, Math.floor(file.size / 2) - Math.floor(CHUNK / 2));
    const mid = file.size > CHUNK * 2 ? file.slice(midStart, midStart + CHUNK) : new Blob();
    const tail = file.size > CHUNK ? file.slice(Math.max(CHUNK, file.size - CHUNK)) : new Blob();
    const buf = await new Blob([head, mid, tail]).arrayBuffer();
    const hash = await crypto.subtle.digest("SHA-256", buf);
    const hex = [...new Uint8Array(hash)].map((b) => b.toString(16).padStart(2, "0")).join("");
    return `${file.size}:${hex}`;
  } catch {
    return null;
  }
}
